import { ModalService } from "./ModalService";
import { StickyService } from "./StickyService";
import { ToastService } from "./ToastService";

export const Sticky = new StickyService();
export const Toast = new ToastService();
export const Modal = new ModalService();